import { ArrowLeft, ArrowRight, X } from "lucide-react";
import { financeExplorerDimensionLabels, type FinanceExplorerDimension } from "@chro/shared";

export type FinanceExplorerGroup = FinanceExplorerDimension;
export const financeExplorerGroupLabels = financeExplorerDimensionLabels;

export function FinanceExplorerGrouping({ value, onChange }: { value: FinanceExplorerGroup[]; onChange: (value: FinanceExplorerGroup[]) => void }) {
  const move = (index: number, direction: -1 | 1) => {
    const next = [...value];
    [next[index], next[index + direction]] = [next[index + direction]!, next[index]!];
    onChange(next);
  };
  return <fieldset className="fin-grouping">
    <legend>Grouping order</legend>
    <p className="fin-copy">Read from left to right. Expand a group to see the next level; reorder or remove levels to change the view.</p>
    <ol aria-label="Explorer grouping order">
      {value.map((field, index) => <li key={field}>
        <span>{index + 1}. {financeExplorerGroupLabels[field]}</span>
        <button type="button" aria-label={`Move ${financeExplorerGroupLabels[field]} earlier`} disabled={index === 0} onClick={() => move(index, -1)}><ArrowLeft size={13} aria-hidden="true" /></button>
        <button type="button" aria-label={`Move ${financeExplorerGroupLabels[field]} later`} disabled={index === value.length - 1} onClick={() => move(index, 1)}><ArrowRight size={13} aria-hidden="true" /></button>
        <button type="button" aria-label={`Remove ${financeExplorerGroupLabels[field]} grouping`} onClick={() => onChange(value.filter((group) => group !== field))}><X size={13} aria-hidden="true" /></button>
      </li>)}
    </ol>
    {value.length === 0 && <p className="fin-copy">All source items are shown individually.</p>}
    <div className="flex flex-wrap gap-2">{(Object.keys(financeExplorerGroupLabels) as FinanceExplorerGroup[]).filter((field) => !value.includes(field)).map((field) => <button key={field} type="button" className="fin-btn" onClick={() => onChange([...value, field])}>Add {financeExplorerGroupLabels[field]} grouping</button>)}</div>
  </fieldset>;
}
